import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Spinner from 'learn-common-spinner';

import styles from './Button.scss';

const Button = ({
  children,
  disabled,
  link,
  loading,
  onClick,
  primary,
  secondary,
  text,
  type,
  className,
  fullWidth,
  name,
  value,
  ...rest
}) => {
  const buttonType = link ? 'button' : type;

  const classes = cn({
    btn: !link,
    [styles.custom]: !link,
    [className]: !!className,
    'btn-link': link,
    [styles.link]: link,
    'btn-primary': primary,
    'btn-secondary': secondary,
    'btn-block': fullWidth
  });

  return (
    <button
      {...rest}
      className={classes}
      disabled={disabled || loading}
      name={name}
      type={buttonType}
      value={value}
      onClick={onClick}
    >
      {!loading && (text || children)}
      {loading && <Spinner />}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  link: PropTypes.bool,
  loading: PropTypes.bool,
  name: PropTypes.string,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  text: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  onClick: PropTypes.func
};

Button.defaultProps = {
  children: undefined,
  className: undefined,
  disabled: false,
  link: false,
  loading: false,
  primary: false,
  secondary: false,
  onClick: undefined,
  text: '',
  type: 'submit',
  name: undefined,
  value: undefined,
  fullWidth: false
};

export default Button;
